<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

    



</div>
</template>

<script>
import moment from 'moment';



//, 'sess', 'ann'
export default {
        props: [ 'stud' ],

        data() {
            return {

            }
        },



mounted() {



}, // END CREATED

methods : { 




}, // END METHODS


}
</script>